import HttpService from "@/services/HttpService";
import Apis from "@/services/Apis";
import { defaultSelectedPayment } from "@/views/Payment/inputs";
const state = {
  payments: [],
  payment: { ...defaultSelectedPayment },
  loadingStatus: {
    savePayment: false,
    getPayments: false,
    getPaymentById: false,
    deletePayment: false,
  },
  paymentPopUp: {
    isOpen: false,
  },
  selectedFilter: undefined,
  selectedPreFilters: undefined,
  sort: undefined,
  pagination: { skip: 0, limit: 20 },
  initialFilter: undefined
};

const mutations = {
  setLoadingStatus: (state, payload) => {
    if (payload) {
      state.loadingStatus[payload.api] = payload.status;
    }
  },
  setPayments: (state, payload) => {
    state.payments = payload;
  },
  setPayment: (state, payload) => {
    if (payload._id === "NEW") state.payment = { ...defaultSelectedPayment };
    else state.payment = payload;
  },
  setSelectedFilter: (state, payload) => {
    state.selectedFilter = payload;
  },
  setSelectedPreFilters: (state, payload) => {
    state.selectedPreFilters = payload;
  },
  setPaymentPopUp: (state, payload) => {
    state.paymentPopUp = payload;
  },
  updateSort: (state, payload) => {
    state.sort = payload;
  },
  updatePagination: (state, payload) => {
    state.pagination = payload;
  },
  updateInitialFilter: (state, payload) => {
    state.initialFilter = payload;
  },
};

const getters = {
  payments: (state) => state.payments,
  payment: (state) => state.payment,
  loadingStatus: (state) => state.loadingStatus,
  filterCriteria: (state) => state.filterCriteria,
  selectedFilter: (state) => state.selectedFilter,
  paymentPopUp: (state) => state.paymentPopUp,
  selectedPreFilters: (state) => state.selectedPreFilters,
  sort: (state) => state.sort,
  pagination: (state) => state.pagination,
  initialFilter: (state) => state.initialFilter,
};

const actions = {
  savePayment: ({ commit, state }, payload) => {
    commit("setLoadingStatus", { api: "savePayment", status: true });
    HttpService.post(
      Apis.backendBaseUrl + Apis.savePayment,
      payload.payment,
      function (response, error) {
        commit("setLoadingStatus", {
          api: "savePayment",
          status: false,
        });
        if (response) {
          commit(
            "setMessage",
            { text: "Saved", type: "success" },
            { root: true }
          );
          if (payload.positiveCallback) {
            payload.positiveCallback(response.data.body);
          }
        } else {
          console.log(error);
          commit(
            "setMessage",
            { text: error.message, type: "error" },
            { root: true }
          );
        }
      }
    );
  },
  deletePayment: ({ commit, state }, payload) => {
    commit("setLoadingStatus", {
      api: "deletePayment",
      status: true,
    });
    HttpService.post(
      Apis.backendBaseUrl + Apis.deletePayment,
      payload.payment,
      function (response, error) {
        commit("setLoadingStatus", {
          api: "deletePayment",
          status: false,
        });
        if (response) {
          commit(
            "setMessage",
            { text: "Deleted", type: "success" },
            { root: true }
          );
          if (payload.positiveCallback) {
            payload.positiveCallback(response.data.body);
          }
        } else {
          console.log(error);
          commit(
            "setMessage",
            { text: error.message, type: "error" },
            { root: true }
          );
        }
      }
    );
  },
  getPaymentById: ({ commit, state }, payload) => {
    commit("setLoadingStatus", {
      api: "getPaymentById",
      status: true,
    });
    HttpService.get(
      Apis.backendBaseUrl + Apis.getPaymentById + "?id=" + payload._id,
      function (response, error) {
        commit("setLoadingStatus", {
          api: "getPaymentById",
          status: false,
        });
        if (response) {
          commit("setPayment", response.data.body);
          if (payload.positiveCallback) {
            payload.positiveCallback(response.data.body);
          }
        } else {
          commit(
            "setMessage",
            { text: error.message, type: "error" },
            { root: true }
          );
          console.log(error);
        }
      }
    );
  },
  setSelectedFilter: ({ commit, state }, payload) => {
    commit("setSelectedFilter", payload);
  },
  setPaymentPopUp: ({ commit, state }, payload) => {
    commit("setPaymentPopUp", payload);
  },
  setSelectedPreFilters: ({ commit, state }, payload) => {
    commit("setSelectedPreFilters", payload);
  },
  updateSort:({ commit, state }, payload) => {
    commit("updateSort", payload)
  },
  updatePagination:({ commit, state }, payload) => {
    commit("updatePagination", payload)
  },
  updateInitialFilter:({ commit, state }, payload) => {
    commit("updateInitialFilter", payload)
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
